import React from "react";

interface Props {
  label: string;
  selected: boolean;
  onClick: () => void;
  icon?: string;
}

export default function SelectableOptionCard({ label, selected, onClick, icon }: Props) {
  const checkbox = (
    <span className={`customize-tour-form__option-check${selected ? " is-selected" : ""}`}>
      {selected && <span className="customize-tour-form__option-check-dot" />}
    </span>
  );

  return (
    <button
      type="button"
      className={`customize-tour-form__option-card${icon ? " customize-tour-form__option-card--icon" : ""}${selected ? " customize-tour-form__option-card--selected" : ""}`}
      onClick={onClick}
    >
      {!icon && checkbox}
      {icon && <img className="customize-tour-form__option-icon" src={icon} alt="" aria-hidden="true" />}
      <span className="customize-tour-form__option-label">{label}</span>
      {icon && checkbox}
    </button>
  );
}
